import { db as firestore, auth } from '../firebase';
import { getDoc, doc } from 'firebase/firestore';
import dexie from '../offlineDB';
import { flushPendingWrites } from './flushPendingWrites';

export async function loadSetHybrid(user, id) {
  try {
    console.log('[Hybrid] Loading set with user:', user);
    console.log('[Hybrid] Firebase Auth:', auth.currentUser);
    console.log('[Hybrid] Set ID:', id);

    if (!user?.uid || !id) {
      console.warn('[Hybrid] Missing user.uid or set ID');
      return await dexie.sets.get(id); // fallback only
    }

    if (navigator.onLine && auth.currentUser) {
      await flushPendingWrites(user);
      const docRef = doc(firestore, 'users', user.uid, 'sets', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        await dexie.sets.put(data);
        console.log('[Hybrid] Loaded set from Firestore:', data);
        return data;
      } else {
        console.warn('[Hybrid] Set not found in Firestore');
      }
    }

    const offline = await dexie.sets.get(id);
    console.log('[Hybrid] Loaded set from Dexie:', offline);
    return offline;

  } catch (err) {
    console.error('Hybrid set load failed:', err);
    return null;
  }
}
